// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"629506b5","223":"0225095e","404":"2fd1372e","588":"11ccd1a1"}[chunkId] + ".chunk.js";
};